import React from 'react';
import { motion } from 'framer-motion';
import { HashLink } from 'react-router-hash-link';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Hero = () => {
  return (
    <section id="top" className="relative min-h-screen flex items-center justify-center pt-16 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-slate-50 -z-20"></div>
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-slate-100 to-transparent -z-10 opacity-60"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-teal-50 rounded-full blur-3xl -z-10 opacity-50"></div>

      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="order-2 md:order-1"
        >
          <div className="inline-block px-3 py-1 mb-6 text-xs font-semibold tracking-wider text-teal-700 uppercase bg-teal-100 rounded-full">
            Advisor • Builder • Strategist
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.1] mb-6">
            Building Trust in a <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">Zero-Trust</span> World.
          </h1>
          <p className="text-lg md:text-xl text-slate-600 mb-8 max-w-lg leading-relaxed">
            With over <strong>25+ years of experience</strong> in cybersecurity and identity, I help global institutions and startups build resilient systems that are secure by design.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <HashLink 
              smooth
              to="/#contact" 
              className="inline-flex items-center justify-center px-8 py-3.5 text-base font-medium text-white bg-slate-900 rounded-lg hover:bg-teal-600 transition-all shadow-lg hover:shadow-teal-500/20"
            >
              Start a Conversation
            </HashLink>
            <HashLink 
              smooth
              to="/#projects" 
              className="inline-flex items-center justify-center px-8 py-3.5 text-base font-medium text-slate-700 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 hover:text-teal-600 transition-all"
            >
              View Selected Work
              <SafeIcon icon={FiArrowRight} className="ml-2" />
            </HashLink>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="order-1 md:order-2 flex justify-center md:justify-end relative"
        >
          <div className="relative w-full max-w-md aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/29a20af30bd50f0331d2a32e8bab2d926b9f480b7a7f7fa86d6a5fc65541d424101393f9afc6e1f60f8b008209294a43/images/aW1hZ2UvanBlZw==/467ac2fd6f933d9e01ce3b20c67fbfeb.jpg" 
              alt="Marjo Villarosa" 
              className="object-cover w-full h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
            <div className="absolute bottom-6 left-6 text-white">
              <p className="font-medium text-lg">Marjo Villarosa</p>
              <p className="text-sm text-slate-200">Cybersecurity & Trust Expert</p>
            </div>
          </div>
          <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-teal-600 rounded-full blur-2xl opacity-20"></div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;